import React, { useEffect } from 'react'
import Modal from '../../../../common/modal'
import { Box, Button, Divider, Grid, Typography } from '@mui/material'
import { useState } from 'react'
import { Item } from '../../../../common/snippets'
import * as sx from '../../../../common/stylesInline/report_daily_branch'
import { focusElemnt } from '../../../../common/helper'
import { useTranslation } from '../../../../../i18n/I18nProvider'

const GSTStatusModal = (props) => {
    const { updateModal, headText, gstData } = props
    const { translations } = useTranslation()
    const bum = translations?.branchAndUserMaster || {}
    const cs = translations?.common || {}
    const modalStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        paddingTop: "24px"

    }

    const gstStatus = [
        { name: bum.gstin || "GSTIN", field: 'GSTIN' },
        { name: cs.companyName || bum.companyName || "Company Name", field: 'CompanyName' },
        { name: bum.tradeName || "Trade Name", field: 'Tradename' },
        { name: bum.address || "Address", field: 'address' },
        { name: bum.status || "Status", field: 'Status' },
    ]
    const [gstStatusValue, setGstStatusValue] = useState({
        GSTIN: "",
        CompanyName: '',
        Tradename: '-',
        address: '',
        Status: ""
    })
    useEffect(() => {
        setGstStatusValue({
            GSTIN: gstData?.GSTIN || '',
            CompanyName: gstData?.CompanyName || '',
            Tradename: gstData?.Tradename || '',
            address: `Building Name : ${gstData?.BuildingName || ''}, Floor No. : ${gstData?.BuildingName || ''}, Street : ${gstData?.Street || ''}, City : ${gstData?.City || ''}, State : ${gstData?.State || ''}`,
            Status: gstData?.Status || ''
        })
    }, [gstData])
    useEffect(() => {
        focusElemnt('okBtn')
    }, [])
    return (
        <Modal
            headTxt={headText}
            width={'30%'}
            updateModal={updateModal}
            closeId={"closeButton"}
            modalClass={'booking-popup'}
            modalStyle={modalStyle}
        >
            <Box sx={{ padding: "12px 16px" }}>
                <Grid container>
                    {gstStatus.map((obj) => <>
                        <Grid item md={4.5} sx={{ paddingY: '6px' }}>
                            <Typography variant='h6' sx={{ fontSize: '14px', color: '#444', fontWeight: 500 }}>
                                {obj.name}
                            </Typography>
                        </Grid>
                        <Grid item md={7.5} sx={{ paddingY: '6px' }}>
                            <Box sx={{ display: 'flex' }}>
                                <Typography variant='h6' sx={{ paddingX: '8px', fontSize: '14px', color: '#444', fontWeight: 500 }}>
                                    :
                                </Typography>
                                <Typography variant='h6' sx={{ fontSize: '14px', color: '#444', fontWeight: 500 }}>
                                    {gstStatusValue[obj.field]}
                                </Typography>
                            </Box>
                        </Grid>
                    </>)}

                </Grid>
            </Box>
            <Divider />
            <Box sx={{ padding: '12px 16px' }} className='reportButton'>
                <Item sx={{ ...sx.itemsx, display: 'flex', justifyContent: 'center' }} className="disabled-wrapper">
                    <Button variant="contained" id="okBtn" style={{ ...sx.fullHeight, ...sx.novp, width: '100%' }} className="btn btn-primary"
                        onClick={() => {
                            updateModal()
                        }}
                    >
                        {bum.ok || 'Ok'}
                    </Button>
                </Item>
            </Box>

        </Modal>
    )
}

export default GSTStatusModal
